module.exports = __webpack_public_path__ + "img/zhichi (2).c12822a2.png";